export default {
  关于我们: '关于我们',
  云采购: '云采购',
  公司概况: '公司概况',
  平台服务: '平台服务',
  联系我们: '联系我们',
  新手指南: '新手指南',
  隐私权政策: '隐私权政策',
  公告: '公告',
  平台公告: '平台公告',
  法律声明及隐私权政策: '法律声明及隐私权政策',
  商务合作: '商务合作',
  免责声明: '免责声明',
  '版权所有 (C) 广州智会云科技发展有限公司': '版权所有 (C) 广州智会云科技发展有限公司',
  '本网站部分内容由用户自行上传,如权利人发现存在误传其作品情形,请及时与本站联系。':
    '本网站部分内容由用户自行上传,如权利人发现存在误传其作品情形,请及时与本站联系。',
  云展动力版权政策与法律说明: '云展动力版权政策与法律说明',
}
